import { styled } from "styled-components";
import { Drawer, GlobalToken, Modal } from "antd";

export const StyledModal = styled(Modal)<{ theme: { token: GlobalToken } }>`
    .ant-picker {
        width: 100%;
    }
    .ant-modal-body {
        display: flex;
        flex-direction: column;
        gap: ${({ theme: { token } }) => token.padding}px;
    }
`;

export const StyledDrawer = styled(Drawer)`
    .ant-picker {
        width: 100%;
    }
    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        gap: ${({ theme: { token } }) => token.padding}px;
    }
    .save-button {
        width: 100%;
    }
`;

export const getDrawerStyles = (token: GlobalToken) => ({
    header: {
      padding: `${token.padding}px`,
      backgroundColor: token.colorBgContainer,
    },
    body: {
      padding: `${token.padding}px ${token.paddingLG}px`,
      backgroundColor: token.colorBgContainer,
    },
    footer: {
      padding: `${token.padding}px ${token.paddingLG}px`,
      borderTop: `1px solid ${token.colorBorderSecondary}`,
      backgroundColor: token.colorBgContainer,
    },
});